import { createReducer } from 'redux-act';
import {
  fetchMemberFavourites,
  addMemberFavourite,
  removeMemberFavourite,
  setMemberFavourites,
  setMemberFavouriteError,
  clearMemberFavourites,
} from './memberFavouritesActions';

export const status = {
  PENDING: 'pending',
  RESOLVED: 'resolved',
  ERROR: 'error',
};

const initialState = {
  memberFavourites: null,
  status: status.RESOLVED,
};

export const reducer = createReducer(
  {
    [fetchMemberFavourites]: (state) => ({
      ...state,
      status: status.PENDING,
    }),
    [addMemberFavourite]: (state) => ({
      ...state,
      error: null,
      status: status.PENDING,
    }),
    [removeMemberFavourite]: (state) => ({
      ...state,
      error: null,
      status: status.PENDING,
    }),
    [setMemberFavourites]: (state, memberFavourites) => ({
      ...state,
      status: status.RESOLVED,
      memberFavourites,
    }),
    [setMemberFavouriteError]: (state, error) => ({
      ...state,
      status: status.ERROR,
      error,
    }),
    [clearMemberFavourites]: (state) => ({
      ...state,
      memberFavourites: null,
      status: status.RESOLVED,
    }),
  },
  initialState,
);
